import React, { ReactNode } from 'react';

import { ChildProps } from '../interfaces';

export const getChildrenOnDisplayName = (
  children: ChildProps | ChildProps[],
  displayName: string
): ReactNode =>
  React.Children.map(children as ReactNode, (child: any) =>
    child?.type?.displayName === displayName ? child : null
  );
